import { getWildcardPersonsService } from '../services/personsService';

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getWildcardPersons = createAsyncThunk(
  'wildcardPersons/getWildcardPersons',
  async () => {
    const response = await getWildcardPersonsService();
    return response.data;
  }
);

// slice
const wildcardPersonsSlice = createSlice({
  name: 'wildcardPersons',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWildcardPersons.pending, (state) => {
        console.log('Fetching wildcard persons...');
        return state;
      })
      .addCase(getWildcardPersons.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      })
      .addCase(getWildcardPersons.rejected, (state, action) => {
        console.error('Failed to fetch wildcard persons:', action.error);
      });
  },
});

export default wildcardPersonsSlice.reducer;
export const wildcardPersonsActions = wildcardPersonsSlice.actions;
export const wildcardPersonsSelectors = {
  selectWildcardPersons: (state) => state.wildcardPersons,
};